var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9969 3.76067H6.00333C4.76474 3.76067 3.76067 4.76474 3.76067 6.00333V17.9967C3.76067 19.2353 4.76474 20.2393 6.00333 20.2393H17.9969C19.2355 20.2393 20.2396 19.2353 20.2396 17.9967V6.00333C20.2396 4.76474 19.2355 3.76067 17.9969 3.76067Z",
    fill: "#45AF77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64488 7.614C7.99199 7.58089 7.45577 8.11711 7.48888 8.77C7.5171 9.32889 7.97133 9.78311 8.53044 9.81156C9.18333 9.84467 9.71955 9.30844 9.68644 8.65556C9.65799 8.09667 9.20377 7.64245 8.64488 7.61422V7.614Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5811 10.5502H7.59421V16.596H9.5811V10.5502Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3024 10.4078C13.538 10.4078 13.0009 10.7724 12.6253 11.2382V10.5502H10.6384V16.596H12.6253V13.0533C12.6791 12.2922 13.2224 12.0936 13.608 12.0936C14.014 12.0936 14.5267 12.2911 14.5267 13.402V16.5958H16.5136V12.3373C16.5136 12.3373 16.4244 10.4076 14.3024 10.4076V10.4078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2710178b5aa1eefd0b0916a84e9f675f.svg";
export { ForwardRef as ReactComponent };